import type React from "react";
import type { Case, TagApi } from "@/briefpoint-client";
import { PARTY_SPECIFIC_TAGS } from "@/lib/constants";

export async function loadTags(
  tagsSet: React.Dispatch<
    React.SetStateAction<Map<number, string> | undefined>
  >,
  tagsRef: React.RefObject<Map<number, string>>,
  tagApi: TagApi,
) {
  const tagsList = new Map<number, string>();
  const loadedTags = await tagApi.tagFindTags({});

  for (const t of loadedTags) {
    tagsList.set(t.id, t.name);
    if (t.ownerId || PARTY_SPECIFIC_TAGS.find((x) => x === t.name)) {
      tagsRef.current.set(t.id, t.name);
    }
  }
  tagsSet(tagsList);
}

export function filterTagsForParties(
  tags: Map<number, string>,
  _case: Case,
  onlyInclude?: Map<number, string>,
) {
  const ret = new Map<number, string>(tags);

  for (const t of _case.tagIds ?? []) {
    ret.delete(t);
  }

  if (onlyInclude) {
    for (const [key] of ret) {
      if (!onlyInclude.has(key)) {
        ret.delete(key);
      }
    }
  }

  return ret;
}
